<template>
  <div class="select-group-separator">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss">
@use "sass:map";

@import "tir-style-system/expose-variables";
@import "tir-style-system/expose-default-theme";
@import "tir-style-system/core/mixins";
.select-group-separator {
  text-transform: uppercase;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  padding: var(--12, map.get($margins, "12")) var(--12, map.get($margins, "12"))
    var(--4, map.get($margins, "4")) var(--12, map.get($margins, "12"));
  color: var(--text-secondary, map.get($colors, "text-secondary"));
  user-select: none;
}
</style>
